import { useState, useEffect } from 'react';
import { Modal, Input, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import './styles.scss';

interface Props {
  open:      boolean;
  onClose:   () => void;
  onCreate?: (group: { name: string; color: string }) => void | Promise<void>;
  loading?:  boolean;
  /** When provided, the modal is in edit mode (prefilled). */
  initial?:  { name: string; color: string } | null;
}

// Palette — the reference set plus a few extras.
const COLORS = [
  '#2563eb', '#16a34a', '#f59e0b', '#ec4899', '#ef4444',
  '#3b4a7a', '#15803d', '#d97706', '#a21caf', '#b91c1c',
  '#0891b2', '#7c3aed', '#65a30d', '#db2777', '#f97316',
  '#059669', '#e11d48', '#6366f1', '#ca8a04', '#64748b',
];

const CreateGroupModal = ({ open, onClose, onCreate, loading = false, initial = null }: Props) => {
  const [name, setName]   = useState('');
  const [color, setColor] = useState(COLORS[0]);

  useEffect(() => {
    if (open) {
      setName(initial?.name ?? '');
      setColor(initial?.color ?? COLORS[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleCreate = async () => {
    if (!name.trim()) return;
    await onCreate?.({ name: name.trim(), color });
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={620}
      centered
      className="create-group-modal"
    >
      <button className="cgm-close" onClick={onClose}><CloseOutlined /></button>

      <h2 className="cgm-title">{initial ? 'Edit group' : 'Create new group'}</h2>

      <label className="cgm-label">Group Name</label>
      <Input
        className="cgm-input"
        placeholder="Enter group name..."
        value={name}
        onChange={e => setName(e.target.value)}
        size="large"
      />

      <label className="cgm-label">Group Colour</label>
      <div className="cgm-swatches">
        {COLORS.map(c => (
          <button
            key={c}
            className={`cgm-swatch ${color === c ? 'selected' : ''}`}
            style={{ background: c }}
            onClick={() => setColor(c)}
          >
            {color === c && <CheckOutlined />}
          </button>
        ))}
      </div>

      <Button
        type="primary"
        block
        size="large"
        className="cgm-create-btn"
        icon={<CheckOutlined />}
        onClick={handleCreate}
        loading={loading}
        disabled={!name.trim()}
      >
        {initial ? 'SAVE GROUP' : 'CREATE GROUP'}
      </Button>
    </Modal>
  );
};

export default CreateGroupModal;
